import React from 'react';
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import chevronDown from "./chevron-down.svg";
import "./faqs.css"

  
const FAQS = () => {

    const questions = [
        "What is Revise GPT?",
        "How does Revise GPT work?",
        "Is Revise GPT Free?",
        "When Will Revise GPT Be Fully Available?",
        "Can I Customize My Version of Revise GPT?",
    ]

    const answers = [
        "Revise GPT is an innovative AI-driven study tool that helps you review and master any subject. Whether it's last-minute exam prep or getting ready for that upcoming interview, Revise GPT provides personalized assistance to ensure you are well-prepared.",
        "Revise GPT gives you test sets of increasing difficulty and evaluates you on different subtopics of your given topic. It helps you identify knowledge gaps so you know where to concentrate on.",
        "Yes! Currently, Revise GPT is free for all users, making it an accessible tool for everyone looking to improve their study habits and knowledge retention.",
        "We are continually working on enhancing Revise GPT with new features and improvements to enhance your experience. Stay tuned for updates by leaving your email, and you'll be the first to know when we roll out these updates.",
        "Absolutely! We are developing features that will allow you to upload your own study materials, such as documents and notes, to create a personalized revision experience tailored to your needs. Keep an eye out for this exciting update.",
    ]

    const numQuestions = questions.length

    return (
        <div className='faqs'>
            <Accordion className="Accordion" allowMultiple>
            {[...Array(numQuestions)].map((_, idx) => (
                <AccordionItem className="AccordionItem" 
                    header={<div>
                                {questions[idx]}
                                <img src={chevronDown} />
                            </div>}>
                    {answers[idx]}
                </AccordionItem>
            ))}
            </Accordion>
        </div>
    )
    
  }

export default FAQS